/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Breach } from "./Breach";
import { BreachFromJSON, BreachFromJSONTyped, BreachToJSON, BreachToJSONTyped } from "./Breach";

/**
 *
 * @export
 * @interface PaginatedBreachList
 */
export interface PaginatedBreachList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Breach>;
}

/**
 * Check if a given object implements the PaginatedBreachList interface.
 */
export function instanceOfPaginatedBreachList(value: object): value is PaginatedBreachList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedBreachListFromJSON(json: any): PaginatedBreachList {
  return PaginatedBreachListFromJSONTyped(json, false);
}

export function PaginatedBreachListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedBreachList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(BreachFromJSON),
  };
}

export function PaginatedBreachListToJSON(json: any): PaginatedBreachList {
  return PaginatedBreachListToJSONTyped(json, false);
}

export function PaginatedBreachListToJSONTyped(
  value?: PaginatedBreachList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(BreachToJSON),
  };
}
